module.exports = __webpack_public_path__ + "static/img1-6633d09a7824b767f9e61994068520bc.png";